//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './GDTMessageClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetMessagesGDTMessageQueryParameters = {
  id?: number | null | undefined ;
  patientId?: number | null | undefined ;
  from?: Date | null | undefined ;
  to?: Date | null | undefined ;
  direction?: Types.GDTMessageDirection | null | undefined ;
  status?: Types.GDTMessageStatus | null | undefined ;
  pagination_Offset?: number | undefined ;
  pagination_Limit?: number | undefined ;
  sorting_SortField?: string | null | undefined ;
  sorting_SortDirection?: Types.SortDirection | undefined ;
  additionalSorting?: Types.SortingDto[] | null | undefined ;
}

export type RemoveGDTMessageQueryParameters = {
  id: number ;
}

export type UpdateGDTMessageQueryParameters = {
  id: number ;
}

export function getMessagesUrl(id?: number | null | undefined, patientId?: number | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, direction?: Types.GDTMessageDirection | null | undefined, status?: Types.GDTMessageStatus | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined): string {
  let url_ = getBaseUrl() + "/api/gdt/messages?";
if (id !== undefined && id !== null)
    url_ += "Id=" + encodeURIComponent("" + id) + "&";
if (patientId !== undefined && patientId !== null)
    url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
if (from !== undefined && from !== null)
    url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
if (to !== undefined && to !== null)
    url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
if (direction !== undefined && direction !== null)
    url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
if (status !== undefined && status !== null)
    url_ += "Status=" + encodeURIComponent("" + status) + "&";
if (pagination_Offset === null)
    throw new Error("The parameter 'pagination_Offset' cannot be null.");
else if (pagination_Offset !== undefined)
    url_ += "Pagination.Offset=" + encodeURIComponent("" + pagination_Offset) + "&";
if (pagination_Limit === null)
    throw new Error("The parameter 'pagination_Limit' cannot be null.");
else if (pagination_Limit !== undefined)
    url_ += "Pagination.Limit=" + encodeURIComponent("" + pagination_Limit) + "&";
if (sorting_SortField !== undefined && sorting_SortField !== null)
    url_ += "Sorting.SortField=" + encodeURIComponent("" + sorting_SortField) + "&";
if (sorting_SortDirection === null)
    throw new Error("The parameter 'sorting_SortDirection' cannot be null.");
else if (sorting_SortDirection !== undefined)
    url_ += "Sorting.SortDirection=" + encodeURIComponent("" + sorting_SortDirection) + "&";
if (additionalSorting !== undefined && additionalSorting !== null)
    additionalSorting && additionalSorting.forEach((item, index) => {
        for (let attr in item)
			if (item.hasOwnProperty(attr)) {
				url_ += "AdditionalSorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
			}
    });
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getMessagesDefaultOptions: Omit<UseQueryOptions<Types.PageableListDtoOfGDTMessageDto, unknown, Types.PageableListDtoOfGDTMessageDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PageableListDtoOfGDTMessageDto, unknown, Types.PageableListDtoOfGDTMessageDto>, 'queryFn'>> = {
};
export function getGetMessagesDefaultOptions() {
  return getMessagesDefaultOptions;
};
export function setGetMessagesDefaultOptions(options: typeof getMessagesDefaultOptions) {
  getMessagesDefaultOptions = options;
}

export function getMessagesQueryKey(dto: GetMessagesGDTMessageQueryParameters): QueryKey;
export function getMessagesQueryKey(id?: number | null | undefined, patientId?: number | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, direction?: Types.GDTMessageDirection | null | undefined, status?: Types.GDTMessageStatus | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined): QueryKey;
export function getMessagesQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id, patientId, from, to, direction, status, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting,  } = params[0] as GetMessagesGDTMessageQueryParameters;

    return trimArrayEnd([
        'GDTMessageClient',
        'getMessages',
        id as any,
        patientId as any,
        from as any,
        to as any,
        direction as any,
        status as any,
        pagination_Offset as any,
        pagination_Limit as any,
        sorting_SortField as any,
        sorting_SortDirection as any,
        additionalSorting as any,
      ]);
  } else {
    return trimArrayEnd([
        'GDTMessageClient',
        'getMessages',
        ...params
      ]);
  }
}
export function __getMessages(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getMessages(
      context.queryKey[2] as number | null | undefined,       context.queryKey[3] as number | null | undefined,       context.queryKey[4] as Date | null | undefined,       context.queryKey[5] as Date | null | undefined,       context.queryKey[6] as Types.GDTMessageDirection | null | undefined,       context.queryKey[7] as Types.GDTMessageStatus | null | undefined,       context.queryKey[8] as number | undefined,       context.queryKey[9] as number | undefined,       context.queryKey[10] as string | null | undefined,       context.queryKey[11] as Types.SortDirection | undefined,       context.queryKey[12] as Types.SortingDto[] | null | undefined,axiosConfig    );
}

export function useGetMessagesQuery<TSelectData = Types.PageableListDtoOfGDTMessageDto, TError = unknown>(dto: GetMessagesGDTMessageQueryParameters, options?: Omit<UseQueryOptions<Types.PageableListDtoOfGDTMessageDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets GDT messages.
 * @param id (optional) 
 * @param patientId (optional) 
 * @param from (optional) 
 * @param to (optional) 
 * @param direction (optional) 
 * @param status (optional) 
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function useGetMessagesQuery<TSelectData = Types.PageableListDtoOfGDTMessageDto, TError = unknown>(id?: number | null | undefined, patientId?: number | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, direction?: Types.GDTMessageDirection | null | undefined, status?: Types.GDTMessageStatus | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined, options?: Omit<UseQueryOptions<Types.PageableListDtoOfGDTMessageDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetMessagesQuery<TSelectData = Types.PageableListDtoOfGDTMessageDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PageableListDtoOfGDTMessageDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  let patientId: any = undefined;
  let from: any = undefined;
  let to: any = undefined;
  let direction: any = undefined;
  let status: any = undefined;
  let pagination_Offset: any = undefined;
  let pagination_Limit: any = undefined;
  let sorting_SortField: any = undefined;
  let sorting_SortDirection: any = undefined;
  let additionalSorting: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id, patientId, from, to, direction, status, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting,  } = params[0] as GetMessagesGDTMessageQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, patientId, from, to, direction, status, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PageableListDtoOfGDTMessageDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getMessages(context, axiosConfig) : __getMessages,
    queryKey: getMessagesQueryKey(id, patientId, from, to, direction, status, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting),
    ...getMessagesDefaultOptions as unknown as Omit<UseQueryOptions<Types.PageableListDtoOfGDTMessageDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets GDT messages.
 * @param id (optional) 
 * @param patientId (optional) 
 * @param from (optional) 
 * @param to (optional) 
 * @param direction (optional) 
 * @param status (optional) 
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function setGetMessagesData(queryClient: QueryClient, updater: (data: Types.PageableListDtoOfGDTMessageDto | undefined) => Types.PageableListDtoOfGDTMessageDto, id?: number | null | undefined, patientId?: number | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, direction?: Types.GDTMessageDirection | null | undefined, status?: Types.GDTMessageStatus | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined) {
  queryClient.setQueryData(getMessagesQueryKey(id, patientId, from, to, direction, status, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting),
    updater
  );
}

/**
 * Gets GDT messages.
 * @param id (optional) 
 * @param patientId (optional) 
 * @param from (optional) 
 * @param to (optional) 
 * @param direction (optional) 
 * @param status (optional) 
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function setGetMessagesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PageableListDtoOfGDTMessageDto | undefined) => Types.PageableListDtoOfGDTMessageDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function removeUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/gdt/messages/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'GDTMessageClient',
      'remove',
      id as any,
    ]);
}

/**
 * Removes GDT message.
 * @param id The message id.
 */
export function useRemoveMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.remove(id),
    mutationKey: key,
  });
}
  
type Remove__MutationParameters = RemoveGDTMessageQueryParameters

/**
 * Removes GDT message.
 * @param id The message id.
 */
export function useRemoveMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Remove__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemoveGDTMessageQueryParameters}): UseMutationResult<void, unknown, Remove__MutationParameters, TContext> {
  const key = removeMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Remove__MutationParameters) => Client.remove(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function updateUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/gdt/messages/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function updateMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'GDTMessageClient',
      'update',
      id as any,
    ]);
}

/**
 * Updates GDT message.
 * @param id The message id.
 * @param dto Request parameter
 */
export function useUpdateMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.GDTMessageDto, unknown, Types.UpdateGDTMessageDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.GDTMessageDto, unknown, Types.UpdateGDTMessageDto, TContext> {
  const key = updateMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.UpdateGDTMessageDto) => Client.update(id, dto),
    mutationKey: key,
  });
}
  
type Update__MutationParameters = UpdateGDTMessageQueryParameters & {
  dto: Types.UpdateGDTMessageDto;
}

/**
 * Updates GDT message.
 * @param id The message id.
 * @param dto Request parameter
 */
export function useUpdateMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.GDTMessageDto, unknown, Update__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: UpdateGDTMessageQueryParameters}): UseMutationResult<Types.GDTMessageDto, unknown, Update__MutationParameters, TContext> {
  const key = updateMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Update__MutationParameters) => Client.update(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}